import { all } from 'redux-saga/effects'

import watchUpdateUser from './user'

export default function* rootSaga() {
  yield all([watchUpdateUser()])
}
